import { AppBundle } from 'api/optimalprint-sdk.d';
import { matchPath } from 'react-router-dom';
import composeRoutes from 'routes';
import { Category } from 'store/app/types';

const getCurrentRoute = (
  path: string,
  categories: Category[],
  opRoutes: AppBundle.Api.Response.App.V1.RoutingListV1Response.Route[],
) => {
  const routes = composeRoutes(categories, opRoutes);
  return routes.find((route) => matchPath(path, route));
};

export default getCurrentRoute;
